import {FsdGroup, XUi} from './fsd-schema';

/**
 * Headings above the schema's own x-ui groups. A form passes a table to the settings form's
 * `sections` input; a section's member groups then render under its one h3 (no sub-headings),
 * wherever the first of them would have stood, as side-by-side columns in the order listed: each
 * member's first field on top (a switch there becomes a Yes/No select, so the leading controls look
 * alike) and its other fields right under it. Generic: it applies to every template whose x-ui.group
 * names match, and a group in no section stays a standalone h3. Without a table (IFE) every group is
 * a standalone h3.
 *
 * Long term this belongs in the schema (an x-ui.section from vtkpy), so the UI names no group.
 */
export interface SectionHeading {
  title: string;
  groups: string[];
}

/** The VOD forms' table (user decision on #2761: Content Protection on VOD only). */
export const VOD_SECTIONS: SectionHeading[] = [
  {title: 'Content Protection', groups: ['Watermark', 'DRM']},
];

/** What the form renders at top level: one group, or a section heading with its member groups. */
export interface FsdBlock {
  key: string;
  /** The SECTIONS heading; null for a standalone group. */
  title: string | null;
  groups: FsdGroup[];
  /** Section only: one column per member group, its first field leading (a switch as Yes/No select). */
  columns: FsdGroup[];
  /** A ruler before it: every block but the first. */
  ruled: boolean;
}

/**
 * The VOD forms' field hints: the DRMtoday Onboard availability window as days (user decision on
 * #2761). vtkpy hands onboard_window to DRMtoday as given; "available from" a day means from its
 * first second UTC, "available until" a day through its last second UTC (23:59:59Z, inclusive).
 * Long term these belong in the schema's own x-ui (vtkpy), like x-ui.section.
 */
export const VOD_FIELD_HINTS: { [path: string]: XUi } = {
  'onboard_window.start_time': {day: 'start'},
  'onboard_window.end_time': {day: 'end'},
};
